export default __webpack_public_path__ + "static/media/polegarNegativoIcone.257631a8.svg";